import axios from "axios";
const checkEnvironment = (url, apiUrl) => {
  const Environment = process.env.NODE_ENV;
  if (Environment === "development") return url + apiUrl;
  if (Environment === "production")
    return window.env.REACT_APP_API_HOST + apiUrl;
};
// const _basic = "http://114.33.155.37:6080/DTF/API";
const _basic = window.env.REACT_APP_API_DEVELOPMENT_HOST;
const _verifyQueue = "/Verify";
const verifyQueue = axios.create({
  baseURL: checkEnvironment(_basic, _verifyQueue)
});



/**
 * 手動驗證
 * @typedef {{
 * queueNumber: string,
 * queueCode: string,
 * storeID: number,
 * languageID: number,
 * }} manualVerify
 *
 * QRCode驗證
 * @typedef {{
 * queueNumber: string,
 * queueCode: string,
 * storeID: number,
 * }} QRCodeVerify
 *
 * 手動驗證&QRcode會得到的結果
 * @typedef {{
 *  verify: boolean,
 *  childCount: number,
 *  adultsCount: number,
 *  countryID: number,
 *  countryName: string,
 *  storeID: number,
 *  storeName: string
 * }} result
 *
 * 要求驗證碼
 * @typedef {{
 *  email: string,
 *  orderCode: string
 * }} requireVerifyCode
 *
 * 要求驗證碼
 * @typedef {{
 *  email: string,
 *  orderCode: string,
 *  emailVerifyCode: string
 * }} checkVerify
 *
 *
 */

/**
 * @param {manualVerify} manualData
 * @return {result}
 */

// 手動驗證排隊驗證
export const postManualVerifyQueue = async manualData => {
  return await verifyQueue.post("/GetVerifyCode", manualData);
};

/**
 * @param {QRCodeVerify} QRCodeData
 * @return {result}
 */

// QRcode驗證排隊驗證
export const postQRCodeVerifyQueue = async QRCodeData => {
  return await verifyQueue.post("/GetQRCodeVerifyCode", QRCodeData);
};

/**
 * @param {string} orderCode
 */

export const getSendEmail = async (orderCode, storeID, createAt) => {
  return await verifyQueue.get("/SendOrderEmail", {
    params: { orderCode, storeID, createAt }
  });
};


/**
 * @param {string} QRCodeID
 */

export const getQRCodeVerifyOrder = async (QRCodeID) => {
  return await verifyQueue.get("/VerifyQRCodeStatus", {
    // http://localhost:9527/takeOrderOnline?guid=06dd9eb089614939b0db7c7ad1f5cf96
    params: { QRCodeID }
  });
};

/**
 * @param {QRCodeVerify} requireVerifyData
 */

// 要求驗證碼到指定信箱
export const postRequireVerifyCode = async requireVerifyData => {
  return await verifyQueue.post("/SetEmailVerifyCode", requireVerifyData);
};

/**
 * @param {checkVerify} checkVerifyData
 */

// 驗證
export const postCheckVerify = async checkVerifyData => {
  return await verifyQueue.post("/CheckEmailVerifyCode", checkVerifyData);
};
